export default __webpack_public_path__ + "static/media/Retail-hover.0d525fac.svg";